var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('AuctionDetailModal',{ref:"modal",attrs:{"auction":_vm.firstAvailable}})}
var staticRenderFns = []

export { render, staticRenderFns }